import { render, staticRenderFns } from "./SitchAccordion.vue?vue&type=template&id=5d59bfbe&scoped=true&"
import script from "./SitchAccordion.vue?vue&type=script&lang=ts&"
export * from "./SitchAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./SitchAccordion.vue?vue&type=style&index=0&id=5d59bfbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d59bfbe",
  null
  
)

export default component.exports